export const SET_HEADER = 'SET_HEADER';
export const SET_SUB_HEADER = 'SET_SUB_HEADER';
export const SET_CANCELLING_LABEL = 'SET_CANCELLING_LABEL';
export const SET_TOOLTIP_TEXT = 'SET_TOOLTIP_TEXT';
export const SET_SHOW_DISABLED_BTN_ERROR_MSG = 'SET_SHOW_DISABLED_BTN_ERROR_MSG';
export const SET_BLIND_ITEMS_ENABLED = 'SET_BLIND_ITEMS_ENABLED';
export const SET_IS_FETCHING_ADD_CART_ITEM = 'SET_IS_FETCHING_ADD_CART_ITEM';
export const SET_IS_FETCHING_REMOVE_CART_ITEM = 'SET_IS_FETCHING_REMOVE_CART_ITEM';
export const SET_ITEMS_LAYOUT = 'SET_ITEMS_LAYOUT';

export const setHeader = (header) => ({
  type: SET_HEADER,
  data: {
    header,
  },
});

export const setSubHeader = (subHeader) => ({
  type: SET_SUB_HEADER,
  data: {
    subHeader,
  },
});

export const setCancellingLabel = (cancellingLabel) => ({
  type: SET_CANCELLING_LABEL,
  data: {
    cancellingLabel,
  },
});

export const setTooltipText = (tooltipText) => ({
  type: SET_TOOLTIP_TEXT,
  data: {
    tooltipText,
  },
});

export const setShowDisabledBtnErrorMsg = (showDisabledBtnErrorMsg) => ({
  type: SET_SHOW_DISABLED_BTN_ERROR_MSG,
  data: {
    showDisabledBtnErrorMsg,
  },
});

export const setBlindItemsEnabled = (blindItemsEnabled) => ({
  type: SET_BLIND_ITEMS_ENABLED,
  data: {
    blindItemsEnabled,
  },
});

export const setIsFetchingAddCartItem = (isFetchingAddCartItem) => ({
  type: SET_IS_FETCHING_ADD_CART_ITEM,
  data: {
    isFetchingAddCartItem,
  },
});

export const setIsFetchingRemoveCartItem = (isFetchingRemoveCartItem) => ({
  type: SET_IS_FETCHING_REMOVE_CART_ITEM,
  data: {
    isFetchingRemoveCartItem,
  },
});

export const setItemsLayout = (itemsLayout) => ({
  type: SET_ITEMS_LAYOUT,
  data: {
    itemsLayout,
  },
});
